
const Loader = () => {
    return (
        <div className="d-flex justify-content-center h-100">
            <span className="spinner-grow text-app align-self-center">
                
            </span>
        </div>
    )
}

export default Loader;